export enum FeatureToggle {
  marketingToolingEnabled = 'rt_rfm_v2_enabled',
}
